import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideTransloco } from '@ngneat/transloco';
import { appRoutes } from './app.routes';
import { TranslocoHttpLoader } from './transloco-loader';
import { userLangInterceptor } from './api/interceptors/user-lang.interceptor';

const STORAGE_LANG_KEY = 'login-lang';
const supportedLangs = ['en', 'ar', 'ru'] as const;
const ACCEPT_LANGUAGE_PARAM = 'Accept-Language';

function getLangFromQuery(): string | null {
  if (typeof window === 'undefined' || !window.location?.search) return null;
  const params = new URLSearchParams(window.location.search);
  const lang = params.get(ACCEPT_LANGUAGE_PARAM) || params.get('accept-language');
  return lang && supportedLangs.includes(lang as (typeof supportedLangs)[number]) ? lang : null;
}

function getInitialLang(): string {
  const fromQuery = getLangFromQuery();
  if (fromQuery) return fromQuery;
  if (typeof localStorage === 'undefined') return 'en';
  const stored = localStorage.getItem(STORAGE_LANG_KEY);
  return stored && supportedLangs.includes(stored as (typeof supportedLangs)[number])
    ? stored
    : 'en';
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(withFetch(), withInterceptors([userLangInterceptor])),
    provideTransloco({
      config: {
        availableLangs: ['en', 'ar', 'ru'],
        defaultLang: getInitialLang(),
        reRenderOnLangChange: true,
      },
      loader: TranslocoHttpLoader,
    }),
  ],
};
